import Vue from 'vue'
import Router from 'vue-router'
import screenShow from '@/components/screen_show'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'ScreenShow',
      component: screenShow
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js